import * as React from "react";

export const SvgReject = (props) => (
	<svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M10.002 3C6.144 3 3 6.145 3 10.004 3 13.862 6.144 17 10.002 17c3.859 0 7.002-3.138 7.002-6.996C17.004 6.145 13.861 3 10.002 3Zm0 1.46c1.298 0 2.49.442 3.433 1.185l-7.808 7.766a5.523 5.523 0 0 1-1.168-3.407 5.533 5.533 0 0 1 5.543-5.545Zm4.451 2.231a5.529 5.529 0 0 1 1.092 3.313 5.532 5.532 0 0 1-5.543 5.542 5.524 5.524 0 0 1-3.335-1.11l7.786-7.745Z"
			fill={props.color ?? "#A8A8A8"}
		/>
	</svg>
);
